import { AvvirEvent } from "type_aliases";
import AutodeskAssignee from "../../models/api/autodesk_assignee";

export type AutodeskAssigneesLoadedEvent = AvvirEvent<typeof AUTODESK_ASSIGNEES_LOADED, AutodeskAssignee[]>

const autodeskAssigneesLoaded = (assignees: AutodeskAssignee[]): AutodeskAssigneesLoadedEvent => ({
  type: AUTODESK_ASSIGNEES_LOADED,
  payload: assignees
});

export const AUTODESK_ASSIGNEES_LOADED = "autodesk_assignees_loaded";

export default autodeskAssigneesLoaded;